import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { DollarSign, Clock, CreditCard } from "lucide-react";

interface ROIMetrics {
  solo: { roi: string; time_to_lead: string; monthly_spend: string };
  team: { roi: string; time_to_lead: string; monthly_spend: string };
  top_team: { roi: string; time_to_lead: string; monthly_spend: string };
}

interface ROIStripProps {
  metrics: ROIMetrics;
}

export const ROIStrip = ({ metrics }: ROIStripProps) => {
  const tiers = [
    { name: 'Solo Agent', data: metrics.solo, badge: 'Starter' },
    { name: 'Team', data: metrics.team, badge: 'Popular' },
    { name: 'Top Team', data: metrics.top_team, badge: 'Enterprise' },
  ];

  return (
    <div className="grid md:grid-cols-3 gap-6">
      {tiers.map((tier, index) => (
        <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="font-bold text-lg">{tier.name}</h3>
              <Badge variant="secondary">{tier.badge}</Badge>
            </div>
            
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <DollarSign className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <div className="text-sm text-muted-foreground">Average ROI</div>
                  <div className="font-bold text-lg">{tier.data.roi}</div>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <div className="text-sm text-muted-foreground">Time to first lead</div>
                  <div className="font-bold">{tier.data.time_to_lead}</div>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <CreditCard className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <div className="text-sm text-muted-foreground">Typical monthly spend</div>
                  <div className="font-bold">{tier.data.monthly_spend}</div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};
